/* MODULE IMPORTS */
import React, { Component } from "react";
import ContextConstructor from "../Context/ContextProvider";
import sendLogError from "../../sendLogError";

import MGAlertModal from "../MGAlertModal/MGAlertModal";
import MGChipSingleSelect from "../MGChipSingleSelect/MGChipSingleSelect";
import MGMessageBox from "../MGMessageBox/MGMessageBox";
import MGContactButtons from "../MGContactButtons/MGContactButtons";
import MGWarning from "../MGWarning/MGWarning";

/* CSS IMPORT */
import "./GestorPopup.css";
import MGAManager from "../../images/MGAManager.svg";
import ManagerPhone from "../../images/Manager_phone.svg";
import ManagerMail from "../../images/Manager_mail.svg";
import warning_success from "../../images/warning_success.svg";
import warning_error from "../../images/warning_error.svg";
import contact from "../../images/contact.svg";
import close from "../../images/close.svg";

class GestorPopup extends Component {
  static displayName = GestorPopup.name;

  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      manhaSelected: true,
      tardeSelected: false,
      messageSuccess: false,
      contactSucess: false,
      contactError: false,
      messageError: false,
      messageContent: "",
      mobile: "",
      actualDate: null,
      startDate: null,
      endDate: null,
      isButtonDisabled: true,
      isLoading: false,
    };
  }

  handleOptionChange() {
    this.setState({
      manhaSelected: !this.state.manhaSelected,
      tardeSelected: !this.state.tardeSelected,
    });
  }

  sendContact(manager) {
    const email = this.props.hasManager ? manager.email : "";
    const number = this.props.hasManager ? manager.employeeNumber : "";
    const channel = this.state.active === 0 ? "Mensagem" : "Contacto";
    const content =
      this.state.active === 0
        ? this.state.messageContent
        : this.state.manhaSelected
          ? "manha"
          : "tarde";
    this.sendContactRequest(number, channel, content, email);
    this.setState({ isLoading: true });
    setTimeout(async () => {
      this.handleTextChange("");
      this.setState({ isLoading: false });
    }, 10000);
  }

  handleTextChange(t) {
    this.setState({ messageContent: t.trim() });
  }

  messageSuccess() {
    return (
      <MGAlertModal
        content={
          <MGWarning
            icon={warning_success}
            title="Mensagem enviada com sucesso!"
            msg={`O seu Gestor Mutualista contactá-lo-á em data próxima.`}
            primaryButton="Fechar"
            primaryButtonClick={() => {
              this.props.close();
            }}
          />
        }
      />
    );
  }

  contactSuccess() {
    return (
      <MGAlertModal
        content={
          <MGWarning
            icon={warning_success}
            title="Pedido registado com sucesso!"
            msg={`O seu Gestor Mutualista contactá-lo-á em data próxima.`}
            primaryButton="Fechar"
            primaryButtonClick={() => {
              this.props.close();
            }}
          />
        }
      />
    );
  }

  contactError() {
    return (
      <MGAlertModal
        content={
          <MGWarning
            icon={warning_error}
            title="Falha ao enviar o pedido de contacto."
            msg={`Por favor, tente novamente ou selecione outra opção.`}
            primaryButton="Tentar Novamente"
            secondButton="Enviar mensagem"
            primaryButtonClick={() => {
              this.setState({ contactError: false });
            }}
            secondButtonClick={() => {
              this.setState({ contactError: false, active: 0 });
            }}
            secondaryText={"Se necessitar de apoio ou esclarecimento adicional, "}
            linkText={"contacte-nos."}
          />
        }
      />
    );
  }

  messageError() {
    return (
      <MGAlertModal
        content={
          <MGWarning
            icon={warning_error}
            title="Falha ao enviar a mensagem."
            msg={`Por favor, tente novamente ou selecione outra opção.`}
            primaryButton="Tentar Novamente"
            secondButton="Pedir contacto"
            primaryButtonClick={() => {
              this.setState({ messageError: false });
            }}
            secondButtonClick={() => {
              this.setState({ messageError: false, active: 1 });
            }}
          />
        }
      />
    );
  }

  hasManager() {
    const contactType = this.state.active;
    const manhaSelected = this.state.manhaSelected;
    const tardeSelected = this.state.tardeSelected;
    const message = this.state.messageContent;
    const isButtonDisabled = this.state.isButtonDisabled;
    const isLoading = this.state.isLoading;

    return (
      <div className="GestorPopup-overlay">
        <div className="GestorPopup-modal">
          <div className="GestorPopup-hasManager">
            {/* HEADER */}
            <div className="GestorPopup-header">
              <span>Contacte-nos</span>
            </div>
            {/* BODY */}
            <div className="GestorPopup-hasmanager-body">
              <div className="GestorPopup-container-info">
                <div className="GestorPopup-details">
                  <div className="GestorPopup-profile">
                    <img src={MGAManager} />
                  </div>
                  <div>
                    <div className="GestorPopup-name">{this.props.manager.name}</div>
                    <div className="GestorPopup-role">Gestor Mutualista</div>
                  </div>
                </div>

                <div className="GestorPopup-contact">
                  <div>
                    <img src={ManagerPhone} />
                    <span>{this.props.manager.telephone}</span>
                  </div>
                  <div>
                    <img src={ManagerMail} />
                    <span>{this.props.manager.email}</span>
                  </div>
                </div>
              </div>
              {/* CONTACT TYPE */}
              <span className="GestorPopup-contact-type">Forma de contacto</span>
              <div className="GestorPopup-contact-select">
                <MGChipSingleSelect
                  label={"Enviar mensagem"}
                  isSelected={contactType == 0}
                  onClick={() => {
                    this.setState({ active: 0 });
                  }}
                />
                <MGChipSingleSelect
                  label={"Pedir contacto"}
                  isSelected={contactType == 1}
                  onClick={() => {
                    this.setState({ active: 1 });
                  }}
                />
              </div>
              {/* MSG */}
              {contactType == 0 ? (
                <div className="GestorPopup-message">
                  <span>Mensagem para o seu Gestor Mutualista</span>
                  <MGMessageBox
                    value={message}
                    onChange={(t) => {
                      this.handleTextChange(t);
                    }}
                    isEmpty={(e) => {
                      this.setState({ isButtonDisabled: e });
                    }}
                  />
                </div>
              ) : (
                <div className="GestorPopup-schedule">
                  <session>
                    <h5>
                      Escolha o período em que deseja ser contactado pelo seu Gestor Mutualista
                    </h5>
                    <h6>Iremos entrar em contacto consigo dentro de 24 horas.</h6>
                  </session>
                  <session className="GestorPopup-schedule-action-buttons">
                    <MGChipSingleSelect
                      label={"Manhã"}
                      isSelected={manhaSelected}
                      onClick={() => {
                        this.handleOptionChange();
                      }}
                    />
                    <MGChipSingleSelect
                      label={"Tarde"}
                      isSelected={tardeSelected}
                      onClick={() => {
                        this.handleOptionChange();
                      }}
                    />
                  </session>
                </div>
              )}
              <div className="GestorPopup-actions-buttons-container">
                <MGContactButtons
                  primaryLabel={"Enviar"}
                  secundaryLabel={"Cancelar"}
                  primaryButtonClick={() => {
                    this.sendContact(this.props.manager);
                  }}
                  secondaryButtonClick={() => {
                    this.props.close();
                  }}
                  isButtonEnable={isLoading ? false : contactType === 0 ? !isButtonDisabled : true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  hasNoManager() {
    return (
      <div className="GestorPopup-overlay">
        <div className="GestorPopup-modal">
          <div className="GestorPopup-hasNoManager">
            <div className="GestorPopup-hasNoManager-header">
              <span>Contacte-nos</span>
              <img
                src={close}
                onClick={() => {
                  this.props.close();
                }}
              />
            </div>
            <div className="GestorPopup-hasNoManager-body">
              <span>{this.props.defaultContact?.title}</span>
              <div className="GestorPopup-hasNoManager-body-phone">
                <img src={contact} />
                <span>{this.props.defaultContact?.telephone}</span>
              </div>
              <div className="GestorPopup-hasNoManager-description">
                <span>{this.props.defaultContact?.additionalText}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  contactCardContent() {
    const hasManager = this.props.hasManager;
    return hasManager ? this.hasManager() : this.hasNoManager();
  }

  renderContactCard() {
    let totalContent = this.state.messageSuccess
      ? this.messageSuccess()
      : this.state.contactSuccess
        ? this.contactSuccess()
        : this.state.contactError
          ? this.contactError()
          : this.state.messageError
            ? this.messageError()
            : this.contactCardContent();

    return totalContent;
  }

  render() {
    let popupContent = this.renderContactCard();

    return (
      <div className="GestorPopup-container">
        {/* <MGAlertModal content={popupContent} /> */}
        {popupContent}
      </div>
    );
  }

  // SEND
  async sendContactRequest(number, channel, content, email) {
    try {
      const { idToken, selectedUser } = this.context;

      const userID = selectedUser.id || selectedUser.associateId;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      };

      const response = await fetch("/Profile/CreateManagerContactRequest", {
        method: "POST",
        headers,
        body: JSON.stringify({
          employeeNumber: number,
          objectID: userID,
          channel,
          date: new Date(),
          content,
          employeeEmail: email,
        }),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      if (channel === "Mensagem") {
        this.setState({ messageSuccess: true });
      } else {
        this.setState({ contactSuccess: true });
      }
    } catch (err) {
      console.error("Error sending contact request:", err);

      if (channel === "Mensagem") {
        this.setState({
          messageError: true,
        });
      } else {
        this.setState({
          contactError: true,
        });
      }

      sendLogError(err.message, "sendContactRequest");
    }
  }
}
GestorPopup.contextType = ContextConstructor;

export default GestorPopup;
